import { of } from 'rxjs';

import { catchError, map, share, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomerWalletAction } from './customer-wallet.action';
import { CustomerWalletService } from '../../shared/services/customer-wallet/customer-wallet.service';

@Injectable()
export class CustomerWalletEffects {
  constructor(
    private actions$: Actions,
    private customerWalletService: CustomerWalletService
  ) {}

  /** Verifica se o usuário possui assessor exclusivo */
  getCustomerWallet$ = createEffect(() => this.actions$.pipe(
    ofType(CustomerWalletAction.getCustomerWallet),
    switchMap(() =>
      this.customerWalletService.getWallet().pipe(
        map((payload) => {
          return {
            payload,
            type: CustomerWalletAction.getCustomerWalletSuccess,
          };
        }),
        catchError((error) => {
          return of({
            type: CustomerWalletAction.getCustomerWalletError,
            payload: error.message || error,
          });
        })
      )
    ),
    share()
  ));
}
